import { FC, useState } from 'react';
import { Box, Typography } from '@altermaind/web/ui';
import { Tooltip } from '../Tooltip/Tooltip';

type Props = {
  currentPercentage?: number;
};

export const ProgressBar: FC<Props> = ({ currentPercentage }) => {
  const [customShow, setCustomShow] = useState(false);

  return (
    <Box
      style={{ cursor: 'pointer', position: 'relative' }}
      borderRadius='xxl'
      height='xxs'
      width='100%'
      backgroundColor={'rgb(255, 255, 255, 0.3)' as never}
      display='flex'
      onMouseEnter={() => setCustomShow(true)}
      onMouseLeave={() => setCustomShow(false)}
    >
      <Box
        borderRadius='xxl'
        height='xxs'
        width={`${currentPercentage ?? 0}%`}
        backgroundColor='white'
      />
      <Tooltip customShow={customShow} iconProps={{ fill: 'transparent' }}>
        <Typography variant='p3/label' fontFamily='regular' color='grey/dark'>
          {currentPercentage ?? 0}%
        </Typography>
      </Tooltip>
    </Box>
  );
};
